import React from 'react';
import Banner from '../Banner/Banner';
import Catagory from '../Catagory/Cetagory';
import Feature from '../Feature/Feature';
const Home = () => {
    return (
        <div>
            <Banner></Banner>
			<Catagory></Catagory>
			<Feature></Feature>
        </div>
    );
};

export default Home;